<template>
  <RouterView />

  <!-- Sources modal — opened from the header globe on any page (ADR-0029 §5) -->
  <SourcesModal :open="sourcesStore.modalOpen" @close="sourcesStore.closeModal()" />

  <!-- Global toast container (ADR-0029 §6 postMessage outcomes) -->
  <div class="tc-toast-container" aria-live="polite" aria-atomic="false">
    <div
      v-for="toast in sourcesStore.toasts"
      :key="toast.id"
      class="tc-toast"
      :class="toast.variant === 'success' ? 'tc-toast--success' : 'tc-toast--error'"
      role="status"
      :data-testid="`toast-${toast.id}`"
    >
      <span class="tc-toast-message">{{ toast.message }}</span>
      <button
        type="button"
        class="tc-toast-close"
        aria-label="Dismiss"
        @click="sourcesStore.dismissToast(toast.id)"
      >&times;</button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useSourcesStore, useSourcesMessageListener } from './stores/sources';
import SourcesModal from './components/SourcesModal.vue';

const sourcesStore = useSourcesStore();
useSourcesMessageListener();
</script>
